import { axios } from '../util/axios'

const nullifierUrl = process.env.REACT_APP_NULLIFIER_URL || 'https://nullifier.olx.com.br'

const CONFIRM_ENDPOINT = `${nullifierUrl}/deactivation/confirm`

export const confirm = token =>
  axios
    .post(
      CONFIRM_ENDPOINT,
      { token },
      {
        withCredentials: true,
      }
    )
    .then(response => response.data)
